import { Form } from "@/shared/form/Form";
import { FormFieldType } from "@/shared/form/FormDefinition";

/**
 * `content.general` of the Bauwerksbuch report snapshot.
 *
 * `name` is the cover *title* of the report, exactly as in B1300 — not a report
 * setting. The backend pre-fills it with "BAUWERKSBUCH nach §128a WBO" when it
 * seeds the snapshot, and the user overwrites it here per report.
 *
 * Only the two genuinely per-report fields are required. Everything that is
 * seeded from the standard-text catalog stays optional, because the catalog
 * registers no value rows and is authored through the settings editor over
 * time — a required empty standard text would block report creation outright.
 */
export interface BauwerksbuchGeneralFormData {
  name: string;
  client: string;
  date: string;
  creator: string;
}

export class BauwerksbuchGeneralForm extends Form<BauwerksbuchGeneralFormData> {
  protected definition = {
    name: { label: "Name", type: FormFieldType.Text, required: true },
    client: {
      label: "Auftraggeber",
      type: FormFieldType.Text,
      required: false
    },
    date: {
      label: "Berichtdatum",
      type: FormFieldType.Date,
      required: false
    },
    creator: {
      label: "Erstellt von",
      type: FormFieldType.Text,
      required: true
    }
  };
}
